const useNetInfo = () => {
  return {
    isConnected: true as boolean | null,
  };
};

export {useNetInfo};
